import * as React from 'react';
import EarningsCallTranscriptListDataGrid from './EarningsCallTranscriptListDataGrid';

export default function EarningsCallTranscriptList({transcript_list} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/earnings_calls">Earnings Calls</a></li>
            <li className="breadcrumb-item"><a href={ "/ticker/" + transcript_list?.ticker }>{transcript_list?.ticker}</a></li>
            <li className="breadcrumb-item active" aria-current="page">{transcript_list.ticker} Earnings Calls</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{transcript_list.company} Earnings Calls Transcripts</h4>
              <p className="card-description">
                Select an earnings call transcript to analyze and review with our AI assistant.
              </p>
              <div>
                <EarningsCallTranscriptListDataGrid transcript_list={transcript_list} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
